import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import {
  ButtonsContainer,
  ButtonWithText,
  ButtonIcon,
  ButtonText,
  TemplateTooltipContainer,
  TemplateTooltip,
} from './style';
import { useResizedImage } from '../../../components2/resizeImage';
import Loader from '../../Loader';
import KebabMenu from '../../../components2/KebabMenu';
import ShareResourcePopup from '../../../components2/ShareResourcePopup';
import ActionPopup from '../../../components2/ActionPopup';
import openArrowIcon from '../../../static/img/Arrow-right-purple-24.svg';
import {
  getOpenButtonAction,
  isNonSystemItem,
  shouldShowButton,
} from './rules';

function Buttons2(props) {
  const {
    item,
    itemType = '',
    onDownload,
    onDelete,
    onClone,
    onPreview,
    onSettings,
  } = props;
  const resizedImages = useResizedImage();
  const history = useHistory();
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [sharedPeople, setSharedPeople] = useState([]);
  const [shareSuccessMessage, setShareSuccessMessage] = useState(null);

  if (!resizedImages) {
    return <Loader />;
  }

  const currentItem = item;
  const isTemplate = !isNonSystemItem(currentItem);

  const handleDownloadClick = (itemToDownload) => {
    if (onDownload) {
      onDownload(itemToDownload || currentItem);
    }
  };

  const handleCloneClick = () => {
    if (onClone) {
      onClone();
    }
  };

  const handlePreviewClick = () => {
    if (onPreview) {
      onPreview();
    }
  };

  const handleDeleteClick = () => {
    if (isTemplate) {
      return;
    }

    if (onDelete && currentItem) {
      onDelete(currentItem.id);
    }
  };

  const handleShareClick = () => {
    if (isTemplate) {
      return;
    }
    setShowSharePopup(true);
  };

  const handleShare = (people, successMessage) => {
    setSharedPeople(people);
    setShareSuccessMessage(successMessage);
    setShowSharePopup(false);
    setShowSuccessPopup(true);
  };

  const handleOpenClickWrapper = (e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }

    const url = getOpenButtonAction(itemType, currentItem);
    if (url) {
      history.push(url);
    }
  };

  const kebabMenuItems = [
    {
      label: 'Share',
      icon: resizedImages.sharePurple,
      action: () => handleShareClick(),
      disabled: isTemplate,
    },
    {
      label: 'Edit',
      icon: isTemplate
        ? resizedImages.editGray || resizedImages.edit
        : resizedImages.edit,
      action: () => handleOpenClickWrapper(),
      disabled: isTemplate,
    },
    {
      label: 'Duplicate',
      icon: resizedImages.duplicate,
      action: () => handleCloneClick(),
    },
    {
      label: 'Download',
      icon: resizedImages.export,
      action: () => handleDownloadClick(currentItem),
    },
    {
      label: 'Delete',
      icon: resizedImages.deleteNew,
      action: () => handleDeleteClick(),
      disabled: isTemplate,
    },
  ];

  const getShareItems = () => {
    if (!currentItem || !currentItem.id) {
      return [];
    }

    // Determine shareType from itemType
    if (itemType === 'commentBank' || itemType === 'Comment Bank') {
      return [
        {
          id: currentItem.id,
          shareType: 'commentBank',
          name: currentItem.title || 'Comment Bank',
        },
      ];
    }
    if (
      itemType === 'markingCriteria' ||
      itemType === 'Marking Criteria' ||
      itemType === 'Rubrics'
    ) {
      return [
        {
          id: currentItem.id,
          shareType: 'markingCriteria',
          name: currentItem.title || 'Rubrics',
        },
      ];
    }
    if (itemType === 'successCriteria' || itemType === 'Success Criterias') {
      return [
        {
          id: currentItem.id,
          shareType: 'successCriteria',
          name: currentItem.title || 'Success Criterias',
        },
      ];
    }
    return [];
  };

  return (
    <ButtonsContainer>
      {shouldShowButton(onClone) && (
        <>
          <ButtonWithText
            onClick={(e) => {
              e.stopPropagation();
              handlePreviewClick();
            }}
          >
            <ButtonIcon src={openArrowIcon} alt="Open" />
            <ButtonText>Open</ButtonText>
          </ButtonWithText>

          {isTemplate ? (
            <TemplateTooltipContainer>
              <ButtonWithText disabled>
                <ButtonIcon src={resizedImages.editGray || resizedImages.edit} alt="Edit" />
                <ButtonText>Edit</ButtonText>
              </ButtonWithText>
              <TemplateTooltip className="template-tooltip">
                Create a duplicate to edit
              </TemplateTooltip>
            </TemplateTooltipContainer>
          ) : (
            <ButtonWithText onClick={handleOpenClickWrapper}>
              <ButtonIcon src={resizedImages.edit} alt="Edit" />
              <ButtonText>Edit</ButtonText>
            </ButtonWithText>
          )}

          <Tooltip title="Create a duplicate to edit" arrow placement="top">
            <ButtonWithText onClick={handleCloneClick}>
              <ButtonIcon src={resizedImages.duplicate} alt="Duplicate" />
              <ButtonText>Duplicate</ButtonText>
            </ButtonWithText>
          </Tooltip>

          <KebabMenu menuItems={kebabMenuItems} />
        </>
      )}

      <ShareResourcePopup
        open={showSharePopup}
        onClose={() => setShowSharePopup(false)}
        items={getShareItems()}
        onShare={handleShare}
      />

      <ActionPopup
        open={showSuccessPopup}
        onClose={() => {
          setShowSuccessPopup(false);
          setShareSuccessMessage(null);
        }}
        type="share"
        message={shareSuccessMessage || 'You have shared with'}
        emailList={sharedPeople}
        primaryButtonLabel="Awesome!"
        primaryButtonAction={() => {
          setShowSuccessPopup(false);
          setShareSuccessMessage(null);
        }}
      />
    </ButtonsContainer>
  );
}
export default Buttons2;
